async function getClientesReferencial(idcliente) {
  const cnpjLimpo = idcliente ? idcliente.replace(/[.\-\/]/g, '') : '';
  
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      access_token: sessionStorage.getItem("token"),
      idcliente: cnpjLimpo,
    }),
  };

  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "sensidia/gestao_clientes/get_clientes_referencial.php", requestOptions);
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    const json = await response.json();
        return json;
  } catch (error) {
    console.error("Erro ao buscar os dados do referencial: ", error);
    return null;
  }
}

export { getClientesReferencial };
